export const SectionLoader = () => {
  return (
    <div className="flex justify-center items-center h-32">
      <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-[#18f7b1]"></div>
    </div>
  );
};
